import { StyleSheet } from 'react-native';
import { PALETTE } from '../../../../constants';

export default StyleSheet.create({
  logo: {
    height: 30,
    width: 30,
    paddingLeft: 30
  },
  displayPdf: {
    justifyContent: 'center',
    alignItems: 'center',
    flex: 1,
    alignSelf: 'center'
  },
  pdfContainer: {
    flex: 1,
  },
  centerMiddle: {
    position: 'absolute',
    zIndex: 4,
  },
  mainWrapper:{
    flex:1,
    marginTop:10
  },
  textAlign:{
    textAlign:'center'
  },
  seperationBdr: {
    borderWidth: 0.5,
    borderColor: PALETTE.primaryStrokeLine,
    height: 1
  },
  contentBorder: {
    marginTop:15,
    borderWidth: 0.5,
    borderColor: PALETTE.primaryStrokeLine,
  }
});
